import CaroselloPartner from "../Components/CaroselloPartner";
import AccordionFAQ from "../Components/AccordionFAQ";
import StatisticheAzienda from "../Components/StatisticheAzienda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import "./Home.css";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import constants from '../Utils/constants';

function Home() {
  const navigate = useNavigate()
  const search = () => navigate({pathname:'/search', search: `?${createSearchParams({q: testoRicerca})}`})
  const [testoRicerca, setTestoRicerca] = useState("");
  const [stats, setStats] = useState( {
    'Orders': 30,
    'Orders3Y': 9,
    'Simples': 4,
    'Published': 489,
  })
  useEffect(() => {
    fetch(`${constants.baseUrl}/stats.php`)
    .then(response => {
      if(response.ok) {
        return response.json();
      }
      throw response;
    })
    .then(d => {
      setStats(d)
    })
    .catch(e =>
      console.log(e)
    )
  }, [])
  return (
    <div className="Home">
      <div className="search-bar">
        <input
          className="search-input"
          type="text"
          placeholder='Cerca qui i prodotti di tuo interesse! es. "Notebook Ryzen", "Frullatore Verde", "Monitor Samsung" oppure incolla direttamente il codice prodotto o il nostro codice che inizia con VLX!'
          value={testoRicerca}
          onChange={(e) => {e.preventDefault(); setTestoRicerca(e.target.value)}}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              search();
            }
          }}
       />
        <button className="search-button" onClick={(e) => {e.preventDefault(); search()}}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          Cerca
        </button>
      </div>
      <div className="introduzione">
        <h2 className="titolo-homepage">
          Semplifica e ottimizza la tua esperienza con il portale della pubblica
          amministrazione!
        </h2>
        <h3 className="sottotitolo-homepage ">
          Scopri la qualità della consulenza tecnica e la velocità di evasione di Virtual Logic
        </h3>
      </div>
      <div className="card-container">
        <div className="card-list">

          <a className="card" href="/search">
            <img className="icona-card" src="img/icone-servizi/mepa.svg" alt="immagine per indicare il nostro catalogo"></img>
            <h3 className="titolo-card">
              Catalogo
              <br />
              prodotti
            </h3>
            <p className="paragrafo-card">
              Il nostro catalogo è il più completo e aggiornato presente sul
              mepa, inoltre è facilmente consultabile anche sul nostro sito!
            </p>
            <span className="bottone-card">SFOGLIA CATALOGO</span>
          </a>

          <a className="card" href="http://www.simplesystems.eu/" target="_blank" rel="noreferrer">
            <img className="icona-card" src="img/icone-servizi/pc.svg" alt="immagine di un pc per indicare i nostri pc simple"></img>
            <h3 className="titolo-card">
              Computer
              <br />
              SIMPLE
            </h3>
            <p className="paragrafo-card">
              Scopri la nostra linea di computer SIMPLE SYSTEM,
              potrai selezionare la configurazione che più si addice alle tue
              esigenze!
            </p>
            <span className="bottone-card">CONFIGURATORE</span>
          </a>
          {/*  href="/order-status" */}

          <a className="card" >
            <img className="icona-card" src="img/icone-servizi/ordini.svg" alt="immagine per indicare un ordine"></img>
            <h3 className="titolo-card">
              Gestione rapida
              <br />
              ordini
            </h3>
            <p className="paragrafo-card">
              Il costante aggiornamento della nostra offerta commerciale sul portale del MEPA ci permette una gestione degli ordini rapida ed efficiente.
            </p>
            <span className="bottone-card-disabled">DISPONIBILE A BREVE</span>
          </a>

          <a className="card" href="/refund">
            <img
              className="icona-card" src="img/icone-servizi/refund.png" alt="immagine che indica la sezione rimborso del sito"></img>
            <h3 className="titolo-card">
              Gestione 
              <br />
              assistenza
            </h3>
            <p className="paragrafo-card">
              Abbiamo semplificato il processo di assistenza per garantire la vostra soddisfazione. 
              Visitate la nostra pagina dedicata per informazioni e assistenza.
            </p>
            <span className="bottone-card">ASSISTENZA</span>
          </a>
          
          <a className="card" href="/contacts">
            <img
              className="icona-card" src="img/icone-servizi/contatti.svg" alt="immagine che indica la sezione contatti del sito"></img>
            <h3 className="titolo-card">
              Contattaci
            </h3>
            <p className="paragrafo-card">
              Il nostro reparto commerciale è preparato per accompagnarvi in
              ogni vostra richiesta, non esitare a contattarci!
            </p>
            <span className="bottone-card">CONTATTACI</span>
          </a>

        </div>
      </div>
      <section className="sezione-about-us">
          <div className="container-testo">
              <h2 className="titolo-container-testo">Chi siamo</h2>
              <p className="paragrafo-container-testo">
              Virtual Logic è un'azienda che opera con successo nel settore delle soluzioni per la pubblica amministrazione, 
              focalizzandosi sul portale Mepa. Da oltre 10 anni, ci impegniamo a offrire servizi di alta qualità con 
              l’obbiettivo di garantire la massima soddisfazione dei nostri clienti. I nostri punti di forza includono un 
              catalogo sempre aggiornato e una gestione rapida degli ordini. Siamo orgogliosi della nostra esperienza nel settore, 
              della precisa conoscenza delle procedure e delle esigenze anche amministrative e procedurali dei nostri clienti. 
              La nostra capacità di fornire soluzioni tecniche personalizzate, con la giusta attenzione agli aspetti economici, 
              è assicurata dal nostro team altamente qualificato e sempre formato. Siamo determinati a mantenere l'eccellenza e 
              la soddisfazione del cliente, con l'intento di costruire relazioni solide e durature. Per saperne di più 
              sulle nostre soluzioni, contattaci oggi stesso.
              </p>
          </div>
          <div className="about-us-img"> </div>
      </section>
      <div className="container-statistiche">
        <section>
          <h2 className="titolo-homepage">Performance</h2>
          <StatisticheAzienda Orders={stats.Orders} Orders3Y={stats.Orders3Y} Simples={stats.Simples} Published={stats.Published} />
        </section>
      </div>
     {/*
      <div className="container-partner">
        <section>
          <h2 className="titolo-partner">I nostri partner</h2>
          <CaroselloPartner />
        </section>
      </div>
        */}
      <div className="container-certificazioni">
        <section>
          <h2 className="titolo-certificazioni">Certificazioni</h2>
          <div className="certificazioni">
            <div className="div-certificazione">
              <img src="/img/certificazioni/iso-9001.png" alt="immagine certificato iso 9001:2015 rilasciato da Audit Service & Certification" />
              <a className="sottotitolo-homepage" href="/assests/Certificato-9001.pdf">ISO 9001</a>
            </div>
            <div className="div-certificazione">
              <img src="/img/certificazioni/iso-14001.png" alt="immagine certificato iso 14001:2015 rilasciato da Audit Service & Certification"/>
              <a className="sottotitolo-homepage" href="/assests/Certificato-14001.pdf">ISO 14001</a>
            </div>
          </div>
        </section>
      </div>
      <div className="container-faq">
        <section>
          <h2 className="titolo-faq">Domande frequenti</h2>
          <AccordionFAQ />
        </section>
      </div>
    </div>
  );
}

export default Home;
